export default __webpack_public_path__ + "static/media/39_desktop.9cc886a3.jpeg";